<template>
  <div class="main" ref="main">
    <!--      按钮组-->
    
    <div class="tools">
      <!-- <el-button-group> -->
        <el-button type="success" plain size="mini" icon="el-icon-plus" @click="openDia($event,'new')">新建</el-button>
        <el-button type="primary" plain size="mini" icon="el-icon-edit" @click="openDia($event,'edit')" :disabled="currentFb=='1'"> 修改</el-button>

        <el-button type="danger" plain size="mini" icon="el-icon-delete" @click="delUser()" :disabled="currentId==0 || currentRow.用户名=='admin'">删除</el-button>
				
    </div>
    <!--      表格-->
	<div class="content">
		<el-table
				:data="tableData"
				border
				size="mini"
				stripe
				highlight-current-row
				:fit="false"
				@row-click="rowClick"
				@row-dblclick="openDia($event,'edit')"
				ref="tabRef"
				:height="tableHeight"
				v-loading = "pictLoading"
				element-loading-background = "rgba(0, 0, 0, 0)"
				element-loading-text = "数据加载中"
				element-loading-spinner = "el-icon-loading"
				:header-cell-style="headClass"
				fit
				>
			<el-table-column type="index" width="50px" align="center"></el-table-column>
		  <el-table-column  prop="用户名" label="用户名" align="center" width="150px"></el-table-column>
		  <el-table-column  prop="创建时间" label="创建时间" align="center" width="100px">
		  	<template slot-scope="scope">
		  		{{scope.row.创建时间.substring(0,scope.row.创建时间.indexOf(' '))}}
		  	</template>
		  </el-table-column>
		</el-table>
		<!--      分页-->
		<div style="text-align: center;margin-top:5px">
		  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			 :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="size"
			 layout="total, sizes, prev, pager, next, jumper"
			 :total="total">
		  </el-pagination>
		</div>
		
	</div>
    
  </div>
</template>

<script>
import * as util from "@/utils/util.js"
  export default {
    data(){
      return{
        tableData:[],
        dialogVisible:false,
        currentId:0,
				currentFb: '0',
        type:"new",
        currentRow:{},
        size:20,
        pageNum:1,
        total:0,
        pictLoading:false,
        totalpage:0,
        tableHeight:500,
        escClose:false,
        dialogTitle:"",
        currentUser: '',
      }
    },
    mounted() {
      this.getUserList()
      let h=280;
      this.$nextTick(() => {
        let height = document.body.clientHeight
        this.tableHeight = height - h
        let that = this
        window.onresize = () => {
          that.tableHeight = document.body.clientHeight - h;
        }
      });
      
    },
		activated(){
			this.getUserList()
		},
    methods:{
      // 表头样式设置
       headClass () {
         return util.tableHeadClass();
       },
      getUserList(){
        this.pictLoading=true
        let url="/Handler/User.ashx?mode=list";
				
				let payload={
					page: this.pageNum,
					pagesize: this.size
				};
				
				this.$ajax.post(url,payload).then(
          response => {
            //console.log(response.data);
						let errorCode=response.data.errorCode;
						
						if(errorCode=='0'){
							this.tableData=response.data.data;
							this.total=response.data.data.length;
							
						}
            else{
							let desc=response.data.desc;
							
							this.$message({
							  type: 'error',
							  message: '获取失败，' + desc
							});
						}
            this.pictLoading=false;
          },
          (err)=> {
            console.log(err);
						this.pictLoading=false;
						
          }
        );
        
      },
      delUser() {
				if(this.currentId==0){
					this.$message({
					  type: 'error',
					  message: '请选择要删除的用户'
					});
					return;
				}
        this.$confirm('确定要删除吗?', '提示', {
          cancelButtonClass: 'btn-custom-cancel',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: false,
        }).then(() => {
        
          var url="/Handler/User.ashx?mode=delete";
          this.$ajax.post(url,{AutoID: this.currentId}).then((response)=>{
            //console.log(response.data);
            //let jsonData=JSON.parse(response.bodyText);
            //console.log(jsonData[0]);
						if(response.data.errorCode=='0'){
							this.currentId=0;
							this.type='del'
							this.getUserList();
						}
            else{
							
							this.$message({
							  type: 'error',
							  message: '删除失败'
							});
						}
        
          },function(err){
            console.log(err);
          });
        });
        
      },
      //单击选中列
      rowClick(row, column, event){
        if(row!==null){
          //console.log(row);
          this.currentId=row.AutoID;
          this.currentRow=row;
					
        }
      },
			view(event,row){
				this.currentId=row.AutoID;
				this.currentRow=row;
				this.openDia(event,'view')
			},
      // 当页面的 每页条数 改变
      handleSizeChange(size){
        this.size=size
        this.getUserList(0)
      },
      // 当前页码改变
      handleCurrentChange(pageNum){
        this.pageNum=pageNum
        this.getUserList(0)
      },
			async openDia(event,type){
			  if(type==="new"){
			    
			    this.$router.push({path: '/user/new'});
			    return;
			  }else if(type==="edit"){
			    if(this.currentId!=0){
			      console.log(this.currentRow);
			      this.$router.push({path: '/user/edit/' + this.currentRow.AutoID});
			      return;
			    }
			    else {
			      return  this.$message.warning("先选择要编辑的用户")
			    }
			
			  }else if(type==="view"){
			    if(this.currentId!=0){
			      
			      this.$router.push({path: '/user/view/' + this.currentRow.AutoID});
			      return;
			    }
			    else {
			      return  this.$message.warning("先选择要查看的用户")
			    }
			  }
			},
			
    },
    props:[]
  }
  // 格式化日期时间 去掉 里面的T 和毫秒数
  export const formatDate = (timestamp) => {
    return timestamp.replace(/T/g,' ').replace(/Z/g,'').slice(0,timestamp.indexOf("."))
  }
  // 格式化时间 只留日期
  function dateFormat(fmt, date) {
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      // "H+": date.getHours().toString(),           // 时
      // "M+": date.getMinutes().toString(),         // 分
      // "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      }
    }
    return fmt;
  }
</script>

<style scoped>
.search{
	padding-top: 5px;
	margin-bottom: -20px;
}
.tools{
	padding: 10px 30px;
	text-align: left;
}
.content{
	padding: 5px 10px;
}
</style>
